




















import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import CommonMixin from '@/mixins/CommonMixin';
import {commitAddNotification} from '@/store/main/mutations';
import { networkErrorMessage } from '@/api';
import { UploadStatus, enqueueUpload, setUploadState, withRetry } from '@/uploadQueue';


@Component({
  components: {
  }
})
export default class ImageUpload extends Mixins(CommonMixin) {
    // Props
    @Prop(String) public readonly field!: string;
    @Prop(Object) public readonly rec!: object;
    @Prop(String) public readonly apiParentUrl!: string;
    @Prop({ type: String, default: '' }) public accept!: string;
    @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;

    public dialogShowPic: boolean = false;
    public imageOnClipBoard: boolean = false;
    public picUrl: string = '';
    // Upload in progress or failed
    public upload: UploadStatus | null = null;
    public uploadTarget = {rec: {} as object, url: ''};
    public apiFileUrl() { return this.apiParentUrl + '/' + this.field; }
    public isUploading() {
        return !!this.upload && this.upload.state === 'uploading';
    }
    public globalKey() {
        return 'image.' + (this as any)._uid;
    }
    public hasImage() {
        if (this.rec && this.rec[this.field] !== null) {
            return true;
        }
        return false;
    }
    public async getImageURL(thumbWidth: number) {
        if (this.hasImage()) {
            const url = await this.api.getFileUrl(this.$store, this.apiFileUrl());
            return url + '?thumb_width=' + thumbWidth;
        } else {
            return '/img/placeholder-image.jpg';
        }
    }
    public async viewImage() {
        if (this.hasImage()) {
            this.picUrl = await this.getImageURL(1000);
            this.dialogShowPic = true;
        }
    }
    public async uploadImage() {
        // console.log('uploadImage', this.field);
        if (this.$refs.fileInput) {
            (this.$refs.fileInput as any).value = ''; // reset any existing files
            (this.$refs.fileInput as any).click();
        }
    }
    public async pasteImage(event) {
        // console.log('pasteImage', this.field);
        const auth = await navigator.permissions.query({name: 'clipboard-read' as PermissionName});
        if (auth.state !== 'denied') {
            const itemList = await (navigator.clipboard as any).read();
            let imageType; // we will feed this later
            const item = itemList.find(itr => // choose the one item holding our image
                itr.types.some(type => { // does this item have our type
                    if (type.startsWith('image/') && !type.includes('svg')) {
                        imageType = type; // store which kind of image type it is
                        return true;
                    }
                }
                )
            );
            const file = item && await item.getType(imageType);
            if (file) {
                this.startUpload(file);
            } else {
                commitAddNotification(this.$store, {content: 'Geen beelden gevonden op klembord', color: 'warning'});
            }
        } else {
            commitAddNotification(this.$store, {content: 'Geen toegang tot klembord', color: 'warning'});
        }
    }
    public async downloadImage() {
        // console.log('downloadImage', this.field, this.rec[this.field]);
        this.api.downloadFile(this.$store, this.apiFileUrl());
    }
    public async deleteImage() {
        // console.log('deleteImage', this.field);
        const response = await this.api.deleteRecord(this.$store, this.apiFileUrl());
        if (response) {
            this.$set(this.rec as any, this.field, null);
        }
        // this.$emit('update');
    }
    public async handleFileInput(event) {
        // console.log('handleFileInput', event);
        const files = event.target.files;
        // console.log(files);
        if (files && files.length) {
            this.startUpload(files[0]);
        }
    }
    public retryUpload() {
        if (this.upload) {
            this.startUpload(this.upload.file, this.uploadTarget);
        }
    }
    public clearUpload() {
        this.upload = null;
        setUploadState(this.globalKey(), null);
    }
    public async startUpload(file: Blob, target = {rec: this.rec, url: this.apiFileUrl()}) {
        // Keep the target: rec may change (dialog reused for another measurement) before a retry
        this.uploadTarget = target;
        const upload: UploadStatus = {state: 'uploading', progress: 0, error: '', file, previewUrl: ''};
        this.upload = upload;
        setUploadState(this.globalKey(), 'uploading');
        try {
            const frec = await enqueueUpload(() => withRetry(async () => {
                upload.progress = 0;
                const formData = new FormData();
                formData.append('file', file);
                const response = await this.api.uploadFileWithProgress(target.url, formData, p => upload.progress = p);
                return response.data;
            }));
            if (this.upload === upload) {
                this.clearUpload();
            }
            this.$set(target.rec as any, this.field, frec);
        } catch (error) {
            upload.state = 'failed';
            upload.error = networkErrorMessage(error);
            if (this.upload === upload) {
                setUploadState(this.globalKey(), 'failed');
            }
            commitAddNotification(this.$store, {
                content: 'Foto NIET opgeslagen (' + upload.error + '). Probeer opnieuw met de knop naast de foto.',
                color: 'error'
            });
        }
    }

    public async handleUploadedFile(frec) {
        // // console.log(frec);
        this.$set(this.rec as any, this.field, frec);
        // this.$emit('update');
    }

    public beforeDestroy() {
        this.clearUpload();
    }


}
